export const FETCH_FINANCIAL_REPORTS_REQUEST = "FETCH_FINANCIAL_REPORTS_REQUEST";
export const FETCH_FINANCIAL_REPORTS_SUCCESS = "FETCH_FINANCIAL_REPORTS_SUCCESS";
export const FETCH_FINANCIAL_REPORTS_FAILURE = "FETCH_FINANCIAL_REPORTS_FAILURE";
